export function getUserId(user) {
  if (user == null) return '';
  const id = user.id ?? user.user_id ?? user.lead_assigned_to ?? user.profile_id;
  return id == null || id === '' ? '' : String(id);
}

export function getUserLabel(user) {
  if (!user) return '';
  const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
  return user.username || user.name || fullName || user.email || '';
}

export function getUserProfileName(user) {
  if (!user) return '';
  if (typeof user.profile_name === 'string' && user.profile_name.trim()) {
    return user.profile_name.trim();
  }
  if (typeof user.profile === 'string' && user.profile.trim()) {
    return user.profile.trim();
  }
  const nestedName = user.profile?.name;
  return typeof nestedName === 'string' ? nestedName.trim() : '';
}

export function formatAssignableUserLabel(user) {
  const name = getUserLabel(user) || getUserId(user);
  const profileName = getUserProfileName(user);
  return profileName ? `${name} · ${profileName}` : name;
}

export function normalizeAssignableUser(user) {
  const id = getUserId(user);
  if (!id) return null;

  const label = getUserLabel(user) || id;
  const profileName = getUserProfileName(user);
  return {
    ...user,
    id,
    value: id,
    label: formatAssignableUserLabel({
      ...user,
      username: user?.username || label,
      profile_name: profileName,
    }),
    username: user?.username || label,
    profile_name: profileName,
  };
}

export function normalizeAssignableUsers(users = []) {
  return (Array.isArray(users) ? users : [])
    .map(normalizeAssignableUser)
    .filter(Boolean);
}

export function getCurrentAssignees(selectedRow) {
  const assignments = selectedRow?.lead_assignment;
  if (!Array.isArray(assignments) || assignments.length === 0) return [];

  return assignments
    .map((item) => normalizeAssignableUser({
      ...item,
      id: item?.lead_assigned_to ?? item?.id ?? item?.user_id,
    }))
    .filter(Boolean);
}

export function getLeadIdsFromRow(selectedRow) {
  const leadId = selectedRow?.lead_id ?? selectedRow?._rawLead?.lead_id;
  return leadId ? [leadId] : [];
}

export function buildAssignPayload({ leadIds = [], campaignId, userIds = [] }) {
  return {
    lead_ids: leadIds,
    campaign_id: campaignId,
    assigned_to_user_ids: userIds,
  };
}

export function buildUnassignPayload({ leadIds = [], campaignId, userIds = [] }) {
  return {
    lead_ids: leadIds,
    campaign_id: campaignId,
    unassign_from_user_ids: userIds,
  };
}

export function hasAssignmentChanges({ selectedUsers = [], unassignQueue = [] } = {}) {
  return selectedUsers.length > 0 || unassignQueue.length > 0;
}

export function isUserAssigned(assignedUsers = [], option) {
  const optionId = getUserId(option);
  if (!optionId) return false;
  return assignedUsers.some((user) => getUserId(user) === optionId);
}

export function parseAssignmentApiError(res, fallback = 'Request failed') {
  const payload = res?.data;
  const data = payload?.data ?? payload;
  const generalError = data?.general_error;

  if (typeof generalError === 'string' && generalError.trim()) return generalError;
  if (generalError?.message) return generalError.message;
  if (typeof data?.message === 'string' && data.message.trim()) return data.message;
  if (typeof payload?.message === 'string' && payload.message.trim()) return payload.message;
  if (typeof res?.message === 'string' && res.message.trim()) return res.message;
  return fallback;
}

export function isAssignmentApiSuccess(res) {
  return res?.status === 200;
}
